export enum LastPageNavType {
  // cfi
  CFI = "cfi",
  // url, e.g. an anchor in a content doc
  URL = "url",
}

export interface LastPage {
  srcCfi: string;
  srcRelatedCfi?: string;
  dest: string;
  destType: LastPageNavType;
  isToggled?: boolean;
}
